import { css } from "@emotion/css";
import { Colors, Spacing } from "@snapchat/snap-design-system";

import { fontFamily } from "./font.styles";

export const formField = css`
    margin-bottom: ${Spacing.MD}px;

    textarea {
        font-family: inherit;
    }
`;

export const inputStyles = css`
    ${fontFamily};
    width: 100%;
    height: 40px;
    padding-left: 8px;

    font-size: 14px;
    font-weight: 400;
    color: ${Colors.Black.V150};

    background: ${Colors.Gray.V50};
    border: none;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    outline: none;

    ::placeholder {
        font-size: 14px;
        font-weight: 400;
        color: ${Colors.Gray.V300};
    }

    :disabled {
        color: ${Colors.Gray.V300};
    }
`;

export const errorTextContainer = css`
    width: 100%;
    padding-top: 4px;

    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    color: ${Colors.Red.V150};
    text-align: left;
`;
